import Axios from './Base'

const API_URL = process.env.VUE_APP_API_URL

export default class Wallet {
  constructor(token) {
    this.token = `Bearer ${token.token}`
    this.wedId = token.token_payload.wed_id
    this.walletApiUrl = API_URL + '/v1/wallets/' + this.wedId
    this.axios = Axios({
      cache: true,
      authorization: this.token,
      wedId: this.wedId,
    })
  }

  getTransactions(page) {
    const params = page ? `?page=${page}` : ''
    return this.axios.get(`${this.walletApiUrl}/transactions${params}`)
  }

  getTransaction(id) {
    return this.axios.get(`${this.walletApiUrl}/transaction/${id}`)
  }

  getDebitTransactions() {
    return this.axios.get(`${this.walletApiUrl}/transactions/debit`)
  }

  getCreditTransactions() {
    return this.axios.get(`${this.walletApiUrl}/transactions/credit`)
  }

  getFutureTransactions() {
    return this.axios.get(`${this.walletApiUrl}/requested-credits`)
  }

  getBonusReceived() {
    return this.axios.get(`${this.walletApiUrl}/bonus/balance`)
  }

  getOrders(id) {
    return this.axios.get(`${this.walletApiUrl}/transaction/${id}/order`)
  }

  getCashbacks(id) {
    return this.axios.get(`${this.walletApiUrl}/transaction/${id}/cashback`)
  }

  getCashbackAmountToReceive() {
    return this.axios.get(`${this.walletApiUrl}/pending-cashback-amount`)
  }

  getSummary(withCurrentWithdrawLimit = false) {
    const params = withCurrentWithdrawLimit
      ? '?with_current_withdraw_limit=true'
      : ''

    return this.axios
      .get(`${this.walletApiUrl}/summary${params}`)
      .then((response) => ({
        ...response.data.data,
        meta: response.data.meta,
      }))
      .catch(() => ({
        pending: true,
      }))
  }

  getExternalToken() {
    return this.axios.get(`${this.walletApiUrl}/external-token`)
  }

  setOwnerInfo(data) {
    return this.axios.post(`${this.walletApiUrl}/owner-info`, data)
  }

  setOnboardPresented() {
    return this.axios.put(
      `${this.walletApiUrl}/notifications/onboarding-presented`
    )
  }

  setSurveyPresented() {
    return this.axios.put(`${this.walletApiUrl}/surveys/withdraw-presented`)
  }

  setSurveyAfterShoppingOrderPresented() {
    return this.axios.put(
      `${this.walletApiUrl}/surveys/withdraw-after-shopping-order-presented`
    )
  }

  setNotificationTooltipPixPresented() {
    return this.axios.put(
      `${this.walletApiUrl}/notifications/tooltip-pix-presented`
    )
  }

  setInviteShoppingRejected() {
    return this.axios.put(
      `${this.walletApiUrl}/notifications/reject-shopping-invite`
    )
  }

  setInviteShoppingAccepted() {
    return this.axios.put(
      `${this.walletApiUrl}/notifications/accept-shopping-invite`
    )
  }

  preWithdraw(data, id, tokens) {
    return this.axios.post(`${this.walletApiUrl}/pre-withdraw`, data, {
      headers: {
        authorization: tokens,
      },
    })
  }

  withdraw(data, id, tokens) {
    return this.axios.post(`${this.walletApiUrl}/withdraw`, data, {
      headers: {
        authorization: tokens,
      },
    })
  }

  countVisit() {
    return this.axios.put(`${this.walletApiUrl}/activities/visit`)
  }

  trackingVisitShopping(data) {
    return this.axios.post(`${this.walletApiUrl}/activities/shopping`, data)
  }

  registerAccountPix(data, id, tokens) {
    return this.axios.post(`${this.walletApiUrl}/bank-account`, data, {
      headers: {
        authorization: tokens,
      },
    })
  }

  getAccountPix() {
    return this.axios.get(`${this.walletApiUrl}/bank-account`)
  }

  sendEmailValidationAccountPix(data) {
    return this.axios.get(
      `${this.walletApiUrl}/bank-account/verification-link?id=${data}`
    )
  }

  set2faSkipped() {
    return this.axios.put(`${this.walletApiUrl}/2fa-skipped`)
  }
}
